import { render, staticRenderFns } from "./PopupDistToBlock.vue?vue&type=template&id=d9f5a000&scoped=true&"
import script from "./PopupDistToBlock.vue?vue&type=script&lang=js&"
export * from "./PopupDistToBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f5a000",
  null
  
)

export default component.exports